export interface IIdentity {
  jwt: string;
  userId: string;
  name: string;
  expiresAt: number;
  role?: string;
  type?: string;
}